import { Link } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';
import { ArrowRight, FileText, Video, BookMarked } from 'lucide-react';

const articles = [
  {
    category: 'Article',
    icon: FileText,
    title: 'Pattern recognition vs. business context: the distinction that changes everything.',
    excerpt: 'Why generic AI bookkeeping tools miss the mark and how a hybrid architecture solves it.',
    tag: 'AI Strategy',
  },
  {
    category: 'Article',
    icon: FileText,
    title: 'How firms are closing the books in 4 days instead of 14.',
    excerpt: 'The operational playbook behind modern close cycles — with exception queues, readiness scoring, and AI-assisted recon.',
    tag: 'Close Ops',
  },
  {
    category: 'Guide',
    icon: BookMarked,
    title: 'A controller\'s guide to rolling out AI bookkeeping without breaking trust.',
    excerpt: 'Change management frameworks, partner buy-in tactics, and phased adoption for conservative firms.',
    tag: 'Leadership',
  },
  {
    category: 'Video',
    icon: Video,
    title: 'Live demo: reconciling a 500-transaction month in 12 minutes.',
    excerpt: 'Watch SnuggleMind\'s Recon Center clear exceptions in real time.',
    tag: 'Product',
  },
  {
    category: 'Article',
    icon: FileText,
    title: 'The hidden cost of chasing missing receipts (and how to eliminate it).',
    excerpt: 'A data-backed look at why missing documents are the single biggest close blocker.',
    tag: 'Operations',
  },
  {
    category: 'Guide',
    icon: BookMarked,
    title: 'Building an audit-ready trail: what your partners actually want to see.',
    excerpt: 'A template firms use to defend every AI decision during review and audit.',
    tag: 'Compliance',
  },
];

export default function ResourcesPage() {
  return (
    <div className="min-h-screen" style={{ background: '#F7F6F2' }} data-testid="resources-page">
      <PublicHeader />

      <section className="pt-20 pb-12 lg:pt-28">
        <div className="max-w-[1280px] mx-auto px-6">
          <p className="text-[11px] uppercase tracking-[0.24em] font-semibold mb-5" style={{ color: '#D98A4A' }}>Resources</p>
          <h1 className="font-heading font-semibold tracking-[-0.03em] mb-6 max-w-4xl" style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)', color: '#0A3622', lineHeight: 1 }}>
            Insights for firms going on offense.
          </h1>
          <p className="text-[18px] leading-relaxed max-w-2xl" style={{ color: '#4B5563' }}>
            Playbooks, guides, and perspectives from the controllers and partners building the future of bookkeeping.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <article
              key={a.title}
              className="p-7 rounded-2xl transition-all duration-200 hover:-translate-y-1 cursor-pointer group"
              style={{ background: '#FFFFFF', border: '1px solid #E5E3DB' }}
              data-testid={`resource-card-${i}`}
            >
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                  <a.icon size={15} style={{ color: '#D98A4A' }} />
                  <span className="text-[11px] uppercase tracking-[0.2em] font-semibold" style={{ color: '#D98A4A' }}>{a.category}</span>
                </div>
                <span className="text-[11px] font-body font-medium px-2.5 py-1 rounded-full" style={{ background: '#F7F6F2', color: '#4B5563' }}>{a.tag}</span>
              </div>
              <h3 className="font-heading text-[20px] font-semibold mb-3 tracking-tight" style={{ color: '#0A3622', lineHeight: 1.25 }}>
                {a.title}
              </h3>
              <p className="text-[14px] leading-relaxed mb-6" style={{ color: '#4B5563' }}>{a.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-[13px] font-body font-semibold transition-transform group-hover:gap-2.5" style={{ color: '#D98A4A' }}>
                Read more <ArrowRight size={14} />
              </span>
            </article>
          ))}
        </div>
      </section>

      <section className="py-20" style={{ background: '#0A3622' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-heading font-semibold tracking-tight text-white mb-5" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1.1 }}>
            Ready to see it in action?
          </h2>
          <Link to="/register" className="inline-flex items-center gap-2 h-12 px-8 rounded-full text-[15px] font-body font-semibold" style={{ background: '#D98A4A', color: '#FFFFFF' }} data-testid="resources-cta">
            Start Free Trial <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
